/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useTexture, useAnimations } from "@react-three/drei";

import useControlAnimal from "../hooks/useControlAnimal";
import useHunt from "../hooks/useHunt";
import useUpdateAnimal from "../hooks/useUpdateAnimal";
import useEndGame from "../hooks/useEndGame";

export default function Fox({}) {

    const [
        fur,
        stilt,
        eye,
    ] = useTexture([
        '/textures/smart_uv_fur_reduced.png',
        '/textures/stilt_reduced.jpg',
        '/textures/eye_reduced.png',
    ])

    const animalRef = useRef();
    const animalName = 'fox';
    const actionName = 'walk';
    const otherAnimalName = 'rabbit';

    const { nodes, materials, animations } = useGLTF("/objects/fuchs_058.glb");
    const { actions } = useAnimations(animations, animalRef);

    useControlAnimal(animalName, actionName, actions);
    useHunt(animalName, actionName, otherAnimalName, actions);
    useUpdateAnimal(animalRef, animalName, actions);
    useEndGame(animalName, actionName, otherAnimalName, actions);

    return (
        <group ref={animalRef} dispose={null}>
            <group name="Scene">
                <group name="rig" scale={0.5} >
                    <primitive object={nodes.root} />
                    <primitive object={nodes.stiltR} />
                    <primitive object={nodes.stiltL} />
                    <group name="Cube001">
                        <skinnedMesh
                            name="Cube002"
                            geometry={nodes.Cube002.geometry}
                            material={materials.skin}
                            skeleton={nodes.Cube002.skeleton}
                        >
                            <meshStandardMaterial map={fur} map-flipY={false} attachArray="material" />
                        </skinnedMesh>
                        <skinnedMesh
                            name="Cube002_3"
                            geometry={nodes.Cube002_3.geometry}
                            material={materials.stilt}
                            skeleton={nodes.Cube002_3.skeleton}
                        >
                            <meshStandardMaterial map={stilt} map-flipY={false} attachArray="material" />
                        </skinnedMesh>
                        <skinnedMesh
                            name="Cube002_1"
                            scale={5}
                            geometry={nodes.Cube002_1.geometry}
                            skeleton={nodes.Cube002_1.skeleton}
                        >
                            <meshStandardMaterial map={eye} attachArray="material" />
                        </skinnedMesh>
                        <skinnedMesh
                            name="Cube002_2"
                            scale={5}
                            geometry={nodes.Cube002_2.geometry}
                            skeleton={nodes.Cube002_2.skeleton}
                        >
                            <meshStandardMaterial map={eye} attachArray="material" />
                        </skinnedMesh>
                    </group>
                </group>
            </group>
        </group>
    );
}

useGLTF.preload("/fuchs_058.glb");

